// extracted by mini-css-extract-plugin
export default {"external":"aW1zgl","icon":"bW1zgl","assetGroupLabel":"cW1zgl"};